(() => {
  if (customElements.get('kiblem-landing')) return;
  class KiblemLanding extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.querySelectorAll('.kiblem-faq').forEach((details) => {
        const sync = () => details.querySelector('summary')?.setAttribute('aria-expanded', String(details.open));
        details.addEventListener('toggle', sync, { signal });
        sync();
      });

    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  }
  customElements.define('kiblem-landing', KiblemLanding);
})();
